import { render, staticRenderFns } from "./Dock.vue?vue&type=template&id=61e80650&"
import script from "./Dock.vue?vue&type=script&lang=js&"
export * from "./Dock.vue?vue&type=script&lang=js&"
import style0 from "./Dock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports